module.exports = __webpack_public_path__ + "static/media/learn_with_us.200fe085.svg";